module.exports = __webpack_public_path__ + "img/course-6.57dc4680.jpeg";